import loader from 'src/hoc/loader'

import { actionClearData, fetchSpacePlans } from './store'
import SpacePlans from './SpacePlans'

const getData = async (props, dispatch) => {
  await dispatch(fetchSpacePlans())
}

const options = {
  onUnmount: dispatch => dispatch(actionClearData()),
}

export default loader(getData, options)(SpacePlans)
